import React, { useContext } from 'react'
import './Footer.css'
import { ThemeContext } from '../../contexts/ThemeContext'

function Footer() {

    const { theme } = useContext(ThemeContext)

    return (
        <footer className="footer" style={{ backgroundColor: theme.secondary }}>
            <p className="footer-line" style={{ color: theme.tertiary70 }}>
                Currently building →{' '}
                <a
                    href="https://webneotech.com"
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: theme.primary }}
                >
                    webneotech.com
                </a>
                {' · Calgary, Alberta'}
            </p>
        </footer>
    )
}

export default Footer
